module.exports = __webpack_public_path__ + "static/img/grow0.a3ca3a13.png";